import { useEffect, useState } from "react";

import { useUbigeoService } from "@/services/ubigeo.service";
import { useSelector } from "react-redux";

export const useUbigeoBeneficiary = ({
  preloadProvinces,
  preloadDistricts,
}) => {
  const { departamentos, departamentoLoading } = useSelector(
    (state) => state.domicilio
  );

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [loadingProvinces, setLoadingProvinces] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [preloadCharged, setPreloadCharged] = useState(false);

  const { getProvince, getDistrict } = useUbigeoService();

  useEffect(() => {
    if (preloadProvinces.length && preloadDistricts.length && !preloadCharged) {
      setProvinces(preloadProvinces);
      setDistricts(preloadDistricts);
      setPreloadCharged(true);
    }
  }, [preloadProvinces, preloadDistricts, preloadCharged]);

  const getProvinces = async (departmentId) => {
    setLoadingProvinces(true);
    try {
      const list = await getProvince({ ideDepartamento: String(departmentId) });
      setProvinces(list);
    } catch (error) {
      setProvinces([]);
    } finally {
      setLoadingProvinces(false);
    }
  };

  const getDistricts = async (departmentId, provinceId) => {
    setLoadingDistricts(true);
    try {
      const list = await getDistrict({
        ideProvincia: String(provinceId),
        ideDepartamento: String(departmentId),
      });
      setDistricts(list);
    } catch (error) {
      setDistricts([]);
    } finally {
      setLoadingDistricts(false);
    }
  };

  const getProvinceDistrictTogether = async (departmentId, provinceId) => {
    setLoadingProvinces(true);
    setLoadingDistricts(true);
    try {
      const [currentProvinces, currentDistricts] = await Promise.all([
        getProvince({ ideDepartamento: String(departmentId) }),
        getDistrict({
          ideProvincia: String(provinceId),
          ideDepartamento: String(departmentId),
        }),
      ]);
      setProvinces(currentProvinces);
      setDistricts(currentDistricts);
    } catch (error) {
      setProvinces([]);
      setDistricts([]);
    } finally {
      setLoadingProvinces(false);
      setLoadingDistricts(false);
    }
  };

  return {
    departments: departamentos,
    provinces,
    districts,
    loadingDepartments: departamentoLoading,
    loadingProvinces,
    loadingDistricts,
    getProvinces,
    getDistricts,
    getProvinceDistrictTogether,
  };
};
